<template lang="pug">
v-row(align="center" class=" tw-h-24 tw-bg-white tw-pt-2  tw-z-40")
  v-col(cols="auto")
    template(v-if="website.logo")
      v-img(:src="path(website.logo)" class=" tw-h-16 tw-w-16 tw-mx-6")
    template(v-else)
      span(:class="titleColor" class=" tw-text-lg tw-font-bold") realtor
  v-spacer
  v-col(cols="auto" class="mr-10")
    v-row(no-gutters class=" tw--mt-3")
      v-col(cols="auto" v-if="website.pages.home.published")
        v-btn(
          small
          :to="`/website`"
          height="35px"
          exact
          text
          rounded
          elevation="0"
          color="black"
          :ripple="false"
          active-class="theme-e-nav-active "
          class="tw-p-0 tw-m-0 theme-e-nav"
        ) {{ website.pages.home.name }}
      v-col(cols="auto" v-if="website.pages.rent.published")
        v-btn(
          small
          :to="`/website/${website.pages.rent.slug}`"
          height="35px"
          text
          rounded
          color="black"
          :ripple="false"
          active-class="theme-e-nav-active "
          class="tw-p-0 tw-m-0 theme-e-nav"
        ) {{ website.pages.rent.name }}
      v-col(cols="auto" v-if="website.pages.buy.published")
        v-btn(
          small
          :to="`/website/sale`"
          height="35px"
          text
          rounded
          :ripple="false"
          color="black"
          active-class="theme-e-nav-active "
          class="tw-p-0 tw-m-0 theme-e-nav"
        ) {{ website.pages.buy.name }}
      v-col(cols="auto" v-if="website.pages.about.published")
        v-btn(
          small
          :to="`/website/${website.pages.about.slug}`"
          height="35px"
          text
          rounded
          :ripple="false"
          color="black"
          active-class="theme-e-nav-active "
          class="tw-p-0 tw-m-0 theme-e-nav"
        ) {{ website.pages.about.name }}
      v-col(cols="auto" v-if="website.pages.contact.published")
        v-btn(
          small
          :to="`/website/${website.pages.contact.slug}`"
          height="35px"
          text
          rounded
          :ripple="false"
          color="black"
          active-class="theme-e-nav-active "
          class="tw-p-0 tw-m-0 theme-e-nav"
        ) {{ website.pages.contact.name }}
  v-spacer
</template>
<script>
export default {
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
};
</script>
<style lang="scss">
.theme-e-nav {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: black !important;
}
.theme-e-nav-active .v-btn__content {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #ffffff !important;
}
.theme-e-nav-active::before,
.theme-e-nav-active {
  opacity: 1 !important;
  background-color: #ed2027 !important;
}
.theme-e-nav:hover::before {
  opacity: 0 !important;
}
</style>
